import React, { useContext, useEffect, useState } from 'react'

import moment from 'moment'
import { Tabs } from 'antd'
import { useSelector } from 'react-redux'

import { Routes } from '../../../routes'
import Analytics from '../../../utils/analytics'
import QuotasProvider from '../../../Providers/Quotas/QuotasProvider'
import PlacesDefiner from '../../../Components/institution/Quotas/definition/PlacesDefiner'
import AllocationProvider from '../../../Providers/Quotas/AllocationProvider'
import PlacesAllocationContainer from '../../../Components/institution/Quotas/allocation/PlacesAllocationContainer'
import SchoolQuotasView from './SchoolQuotasView/SchoolQuotasView'
import { InstitutionOptions } from '../../../utils/constants'
import DefaultContainer from '../../../HOC/DefaultContainer'
import useBetaMode from '../../../hooks/useBetaMode'
import ExperimentalTitle from '../../../Components/shared/ExperimentalTitle'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'

const { TabPane } = Tabs

const QuotasView = () => {
  const { optionsMap } = useContext(InstitutionContext)

  const t = useSelector(selectTranslate)

  const [date, setDate] = useState(moment())

  const betaMode = useBetaMode()

  useEffect(() => {
    Analytics.pageView(Routes.QUOTAS)
  }, [])

  return (
    <QuotasProvider>
      <Tabs defaultActiveKey='1' animated={false} className='flex-fill' destroyInactiveTabPane>
        <TabPane tab={t('Define places')} key='1' className='flex-fill'>
          <PlacesDefiner
            date={date}
            pausesRequired={!!optionsMap[InstitutionOptions.QUOTA_PER_PAUSE]}
            onDateChange={setDate}
          />
        </TabPane>
        <TabPane tab={t('Allow places to schools')} key='2' className='flex-fill'>
          <AllocationProvider>
            <PlacesAllocationContainer />
          </AllocationProvider>
        </TabPane>
        {betaMode.active && (
          <TabPane tab={<ExperimentalTitle title='Allow places to schools V2' />} key='3' className='flex-fill'>
            <AllocationProvider>
              <DefaultContainer>
                <SchoolQuotasView />
              </DefaultContainer>
            </AllocationProvider>
          </TabPane>
        )}
      </Tabs>
    </QuotasProvider>
  )
}

export default QuotasView
